import React, { Component } from 'react';
import { bindActionCreators, Dispatch } from 'redux';
import { connect } from 'react-redux';

import { activeMenu } from '@app/store/actions';
import { mainMenuTypes, IMenuItem } from '@app/components/Sidebar/menuObject';
import { getMenuItemById } from '@app/helpers';

interface IProps {
    actions: {
        activeMenu: Function;
    };
}

interface IState {
    menuItem: IMenuItem;
}

class SystemCatalogPage extends Component<IProps, IState> {

    componentWillMount() {
        this.setMenuItem();
    }

    componentDidMount() {
        this.props.actions.activeMenu(this.state.menuItem.id);
    }

    render() {
        return (
            <h2>
                {this.state.menuItem.name}
            </h2>
        );
    }

    private setMenuItem() {
        const item: IMenuItem | undefined = getMenuItemById(mainMenuTypes.SystemCatalog);

        if (item !== undefined) {
            this.setState({
                menuItem: item
            });
        }
    }
}

const mapStateToProps = (state: any) => ({

});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    actions: bindActionCreators(
        {
            activeMenu
        },
        dispatch
    )
});


export default connect(mapStateToProps, mapDispatchToProps)(SystemCatalogPage);
